import { inject, Injectable } from '@angular/core';
import { Router, NavigationEnd } from '@angular/router';
import { environment } from '../../../../environments/environment';

/**
 * Service that synchronizes the current iframe URL with the parent app (Verity) 
 * by broadcasting URL changes to the parent on navigation end.
 */
@Injectable({
  providedIn: 'root', 
})
export class UrlSynchronizationService {
  private router = inject(Router);
  public allowedTargetUrls: string[] = [
    environment.verity.devUrl,
    environment.verity.stagingUrl,
    environment.verity.prodUrl,
  ];

  public targetUrl: string;

  constructor() {
    window.addEventListener('message', this.targetInitialization.bind(this), false);
    
    // Send a ready signal when the service is initialized
      this.allowedTargetUrls.forEach((target) => {
        window.parent.postMessage(
            { type: 'hunterReady' },
          target
        );
      });
  }
  
  
  /**
  * Initialize target url to be used for broadcasting sent by Verity via postMessage
  */
 public targetInitialization(event: MessageEvent): void {
   if (this.allowedTargetUrls.includes(event.origin)) {
    if (event.data?.type === 'initialize' && event.data.target) {
            const { target } = event.data;
            this.targetUrl = target;
        }
   } else {
    console.warn('Received message from untrusted source:', event.origin);
   }
 }

  /**
   * Listens for Angular navigation events and broadcasts the updated URL to Verity.
   */
  public listenToRouterEvents(): void {
    this.router.events.subscribe((event) => {
      if (event instanceof NavigationEnd) {
        this.broadcastUrl(event.urlAfterRedirects);
      }
    });
  }

  /**
   * Sends the updated URL to the parent window (Verity) to synchronize the URL.
   * @param url - The current URL to broadcast.
   */
  private broadcastUrl(url: string): void {
    if (this.targetUrl) {
      window.parent.postMessage(
        { type: 'urlChanged', url },
        this.targetUrl
      );
    } else {
        // If the target url didn't get set, send broadcasts to all environments
        this.allowedTargetUrls.forEach((target) => {        
            window.parent.postMessage({ type: 'urlChanged', url }, target );
        });
    }
  }
}
